import { Injectable } from '@angular/core';
import moment from 'moment';

@Injectable({
	providedIn: 'root'
})
export class CalendarUtilService {

	constructor() { }

	getDateRangeText(calendar: any, dayView: string): string | null {
		if (!calendar || !calendar.getApi) {
			return null;
		}

		const calendarApi = calendar.getApi();
		const view = calendarApi.view;
		const viewType = view.type;

		const start = moment(view.currentStart);
		const end = moment(view.currentEnd).subtract(1, 'day');

		if (viewType === dayView) {
			return start.format('DD. MMMM YYYY');
		} else {
			if (start.month() === end.month()) {
				return `${start.format('DD.')} — ${end.format('DD. MMMM YYYY')}`;
			} else {
				return `${start.format('DD. MMMM')} — ${end.format('DD. MMMM YYYY')}`;
			}
		}
	}
}
